import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TipoAsignacion } from '../models/tipo-asignacion';

@Injectable()
export class TipoAsignacionService {

  private urlEndPointTipoAsignacion = environment.tipoAsignacionEndPoint;
  

  constructor(private http: HttpClient) { }

  listarTiposAsignacion(): Observable<TipoAsignacion[]>{
    return this.http.get(this.urlEndPointTipoAsignacion).pipe(
      map((respuesta)=> respuesta as TipoAsignacion[])
    )
  }

  tipoAsignacionPorId(id: number): Observable<TipoAsignacion>{
    return this.http.get<TipoAsignacion>(this.urlEndPointTipoAsignacion + id)
  }

  tipoAsignacionPorNombre(nombreAsignacion: string): Observable<TipoAsignacion>{
    return this.http.get<TipoAsignacion>(this.urlEndPointTipoAsignacion + 'pornombre/' + nombreAsignacion)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/tipo-asignacion.service.ts